const sliderData = [
  {
    id: 1,
    tagline: "Multi-day offer",
    title: "Get 30% off when you order for 3 days",
    subtitle: "Select 3 delivery dates to unlock discount",
    cta: "Shop Now",
    image:
      "https://images.unsplash.com/photo-1600891964599-f61ba0e24092",
  },
  {
    id: 2,
    tagline: "TechBegin Deals",
    title: "Smart Gadgets at Best Price",
    subtitle: "Limited time offers",
    cta: "Shop Now",
    image:
      "https://images.unsplash.com/photo-1517336714731-489689fd1ca8",
  },
  {
    id: 3,
    tagline: "New Launch",
    title: "Premium Accessories",
    subtitle: "Upgrade your lifestyle",
    cta: "Explore",
    image:
      "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f",
  },
];

export default sliderData;
